import { useSelector } from "react-redux";
import { ITree } from "../../packages/Api/data/tree/types";
import { selectActiveNodeId, selectContentData, selectData, selectExpandedNodes, selectLoading } from "./selector";

export const useLoading = (): boolean => useSelector(selectLoading);
export const useData = (): ITree[] => useSelector(selectData);
export const useContentData = (): ITree[] | undefined => useSelector(selectContentData);
export const useActiveNodeId = (): string => useSelector(selectActiveNodeId);
export const useExpandedNodes = (): string[] => useSelector(selectExpandedNodes);
